<template lang="pug">
	.audio-tracker-button.flex-row.center.align-center(v-if="visible", @click="v => !disabled && !isBusy && $emit('click')", 
		:class="[disabled || isBusy ? 'disabled' : '', active ? 'active' : '']")
		template(v-if="icon")
			fas(v-if="isFasIcon", :icon="spin ? 'spinner' : fasIcon", :spin="spin")
			i(v-else, :class="[icon]")
		span(v-if="text") {{text}}
		.loader-wrapper(v-if="isBusy")
			.flex-col.full-width.full-height.align-center.center
				Loader(text="")
		.sub
			slot
</template>


<script>
	import VueTypes from 'vue-types';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'audioTracker.AudioTrackerButton',
		name: 'audio-tracker-button',
		components: { Loader },
		props: {
			icon: VueTypes.string.def(null),
			text: VueTypes.string.def(null),
			disabled: VueTypes.any.def(false),
			visible: VueTypes.any.def(true),
			isBusy: VueTypes.bool.def(false),
			active: VueTypes.bool.def(false),
			spin: VueTypes.bool.def(false),
		},
		computed: {
			isFasIcon() {
				return this.icon?.indexOf('fas') > -1;
			},
			fasIcon() {
				return this.icon?.replace(/fas/g,'').replace(/fa-/g,'')?.trim();
			}
		}
	}
</script>
<style lang='scss'>
	.audio-tracker-button {
		@import "main/themes/generated/variables.base.scss";

		position: relative;
		background: #ffffff40;
		border-radius: 4px;
		height: 30px;
		padding: 0px 8px;
		color: #777;
		user-select: none;
		border: 1px solid #e0e0e0;
		min-width: 32px;

		> .sub {
			position: absolute;
			right: 0px;
			bottom: 0px;
		}

		&.small {
			height: 24px;
			min-width: 24px;
			font-size: 80%;
			padding: 0px 4px;
		}

		&.extra-small {
			height: 20px;
			min-width: 20px;
			font-size: 70%;
			padding: 0px 2px;
		}

		&.uppercase {
			text-transform: uppercase;
			font-weight: 500;
			letter-spacing: .04em;
			font-size: 11px !important;
		}

		&.padded {
			margin-bottom: 4px;
		}

		&.success {
			background: #ff866a;
			color: $base-bg;
			border: 1px solid #ff866a;
		}

		&.error {
			color: #ff7b7b;
			border: 1px solid #ff7b7b;
		}

		&.warning {
			color: #ffbd17;
			border: 1px solid #ffbd17;
		}

		&.active {
			background: $base-accent;
			color: $base-bg;
		}

		&:hover:not(.disabled) {
			background: $base-accent;
			color: $base-bg;
			cursor: pointer;
		}

		&.is-muted {
			background: #fffc00;
		}

		&.is-solo {
			background: #00ffa6;
		}

		&:not(.no-space) > * {
			&:not(:first-child) {
				margin-left: 4px;
			}
		}

		&.disabled {
			> * {
				opacity: 0.4;
			}
		}

		.loader-wrapper {
			opacity: 1;
			position: absolute;
			width: 100%;
			height: 100%;
			pointer-events: none;

			> * {
				margin-left: -2px;
			}
		}
	}
</style>
